import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ProcessingInformationComponent } from './components/processing-information/processing-information.component';
import { UpdateSubTaskDetailsComponent } from './components/update-sub-task-details/update-sub-task-details.component';
import { L1RoutingModule } from './l1-routing.module';
import { I140TimelineComponent } from './components/i140-timeline/i140-timeline.component';
import { MainContainerComponent } from './components/main-container/main-container.component';
import { JobDescriptionComponent } from './components/job-description/job-description.component';
import { EfilingSettingComponent, I140SubheaderComponent } from './components/i140-subheader/i140-subheader.component';
import { StatusUpdateComponent } from './components/status-update/status-update.component';
import { AddDutyComponent, JobDutiesComponent } from './components/job-duties/job-duties.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { BeneficiaryPersonalDetailsComponent } from './components/beneficiary-personal-details/beneficiary-personal-details.component';
import { EducationDetailsComponent } from './components/education-details/education-details.component';
//import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
//import 'froala-editor/js/plugins.pkgd.min.js';
import { DeleteDialogComponent } from './components/delete-dialog/delete-dialog.component';
import { DependentDetailsComponent } from './components/dependent-details/dependent-details.component';
import { PetitionerDetailsComponent } from './components/petitioner-details/petitioner-details.component';
import { GetReceiptsComponent } from './components/get-receipts/get-receipts.component';
import { SubmitPetitionComponent } from './components/submit-petition/submit-petition.component';
import { PrintPetitionComponent } from './components/print-petition/print-petition.component';
import { UscisContentComponent } from './components/uscis-content/uscis-content.component';
import { StepStatusUpdatePayload } from './utility/services/stepStatusUpdate.service';
import { NoteDialogComponent } from './components/note-dialog/note-dialog.component';
import { ReviewI140PetitionComponent } from './components/review-i140-petition/review-i140-petition.component';
import { LetterGenerationComponent } from './components/letter-generation/letter-generation.component';
import { I140FileUploadComponent } from './components/i140-file-upload/i140-file-upload.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxPermissionsModule } from 'ngx-permissions';
import { BeneficiaryDocumentsComponent } from './components/beneficiary-documents/beneficiary-documents.component';
import { UpdateDecisionComponent } from './components/update-decision/update-decision.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PastJobDescriptionComponent } from './components/past-job-description/past-job-description.component';
import { PrimengLibraryModule } from 'primeng-library';
import * as fromStore from 'visa-store';
import { BeneficiaryPersonalDetailsLibraryModule } from 'beneficiary-personal-details-library';
import { PetitionerDetailsForeignCompanyComponent } from './components/petitioner-details-foreign-company/petitioner-details-foreign-company.component';
import { EducationDetailsLibraryModule } from 'education-details-library';
import { WorkExperienceDetailsComponent } from './components/work-experience-details/work-experience-details.component';
import { BeneficiaryDocumentsLibraryModule } from 'beneficiary-documents-library';
import { MailingAddressLibraryModule } from 'mailing-address-library';
import { FeeCalculationLibraryModule } from 'fee-calculation-library';
import { ConsulateAddressLibraryModule } from 'consulate-address-library';
import { SubmitPetitionLibraryModule } from 'submit-petition-library';
import { GetReceiptsLibraryModule } from 'get-receipts-library';
import { GenerateFormsLibraryModule } from 'generate-forms-library';
import { UscisContentLibraryModule } from 'uscis-content-library';
import { ReviewCommentsLibraryModule } from 'review-comments-library';
import { ReviewPetitionLibraryModule } from 'review-petition-library';
import { PrintPetitionLibraryModule } from 'print-petition-library';
import { DateFormatModule } from 'date-format';
import { PlaceHolderLibraryModule } from 'place-holder-library';
import { MembershipAssociationComponent } from './components/child-comp-capture-extraordinary-ability-details/membership-association/membership-association.component';
import { ResearchContributionComponent } from './components/child-comp-capture-extraordinary-ability-details/research-contribution/research-contribution.component';
import { EnterEntitiesRelationshipDetailsComponent } from './components/enter-entities-relationship-details/enter-entities-relationship-details.component';
import { LetterGenerationEntryLibraryModule } from 'letter-generation-entry-library';
import { CoverLetterLibraryModule } from 'cover-letter-library';
import { SupportLetterLibraryModule } from 'support-letter-library';
import { OrganizeDocumentsLibraryModule } from 'organize-documents-library';
import { LetterPreviewLibraryModule } from 'letter-preview-library';
import { LetterTemplateLibraryModule } from 'letter-template-library';
import { CreateTemplateLibraryModule } from 'create-template-library';
import { PdfViewLibraryModule } from 'pdf-view-library';
import { PetitionerDetailsLibraryModule } from 'petitioner-details-library';
import { USCISH1BLotteryComponent } from './components/uscis-h1-b-lottery/uscis-h1-b-lottery.component';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { FileUploadLibraryModule } from 'file-upload-library';
import { AwaitLotterySelectionComponent } from './components/await-lottery-selection/await-lottery-selection.component';
import { ItineraryOfServicesComponent } from './components/itinerary-of-services/itinerary-of-services.component';
import { SpecialityOccupationComponent } from './components/speciality-occupation/speciality-occupation.component';
import { OccupationDeterminationComponent } from './components/occupation-determination/occupation-determination.component';
import { OccupationDetailsComponent } from './components/occupation-details/occupation-details.component';
import { LcaComponent } from './components/lca/lca.component';
import { PetitionAnalysisContainerModule } from '../petition-analysis-container/petition-analysis.module';
import { LastUpdateLibraryModule } from 'last-update-library';
import { H1bJobDescriptionComponent } from './components/h1b-job-description/h1b-job-description.component';
import { JobDescriptionLibraryModule } from 'job-description-library';
import { LetterGenerationLibraryModule } from 'letter-generation-library';
import { ItineraryOfServicesLibraryModule } from 'itinerary-of-services-library';
import { ProvideEERComponent } from './components/provide-eer/provide-eer.component';
import { SupervisorDetailsComponent } from './components/supervisor-details/supervisor-details.component';
import { ProjectDetailsComponent } from './components/project-details/project-details.component';
import { ClientProjectDocumentsComponent } from './components/client-project-documents/client-project-documents.component';
import { UpdateEmploymentModule } from '../update-employment/update-employment.module';
import { EnterEntitiesRelationshipDetailsLibraryModule } from 'enter-entities-relationship-details-library';
import { H1bPetitionerDetailsComponent } from './components/h1b-petitioner-details/h1b-petitioner-details.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { HelpVideoOverlayLibraryModule } from 'help-video-overlay-library';
import { PetitionUpdateInitComponent } from './components/update-petition-dialogue/petition-update-init/petition-update-init.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatDividerModule } from '@angular/material/divider';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { PortEntryComponent } from './components/uscis-content/port-entry/port-entry.component';
import { OutsideImagilityComponent } from './components/outside-imagility/outside-imagility.component';
import { CaptureExtraordinaryAbilityDetailsComponent } from './components/capture-extraordinary-ability-details/capture-extraordinary-ability-details.component';
import { L1OutsideImagilityComponent } from './components/l1-outside-imagility/l1-outside-imagility.component';
import { NationalInternationalPrizesComponent } from './components/child-comp-capture-extraordinary-ability-details/national-international-prizes/national-international-prizes.component';
import { AuthorAndPublicationComponent } from './components/child-comp-capture-extraordinary-ability-details/author-and-publication/author-and-publication.component';
import { HighsalaryRemunerationComponent } from './components/child-comp-capture-extraordinary-ability-details/highsalary-remuneration/highsalary-remuneration.component';
import { ArtisticExhibitionsShowcasesComponent } from './components/child-comp-capture-extraordinary-ability-details/artistic-exhibitions-showcases/artistic-exhibitions-showcases.component';
import { ProfessionalPublicationsComponent } from './components/child-comp-capture-extraordinary-ability-details/professional-publications/professional-publications.component';
import { ParticipationAsJudgeComponent } from './components/child-comp-capture-extraordinary-ability-details/participation-as-judge/participation-as-judge.component';
import { EmploymentEssentialCriticalCapacityComponent } from './components/child-comp-capture-extraordinary-ability-details/employment-essential-or-critical-capacity/employment-essential-or-critical-capacity.component';
import { CustomStepsFormComponent } from './components/custom-steps-form/custom-steps-form.component';
import { VisaDesignerModule } from '../visa-designer/visa-designer.module';
import { VdJobDescriptionComponent } from './components/vd-job-description/vd-job-description.component';
import { VdProvidePetitionerDetailsComponent } from './components/vd-provide-petitioner-details/vd-provide-petitioner-details.component';
import { SendNotificationModule } from 'send-notification';
import { SponserPersonalDetailComponent } from './components/sponser-personal-detail/sponser-personal-detail.component';
import { ProvideInformationContainerComponent } from './components/provide-information-container/provide-information-container.component';
import { AddressHistoryComponent } from './components/address-history/address-history.component';
import { AddressComponent } from './components/address/address.component';
import { MaritalHistoryComponent } from './components/marital-history/marital-history.component';
import { ParentInformationComponent } from './components/parent-information/parent-information.component';
import { EmploymentHistoryComponent } from './components/employment-history/employment-history.component';
import { NotificationComponentLibraryModule } from 'notification-component-library';
import { SendBackComponentLibraryModule } from 'send-back-component-library';
import { RequiredDocumentsComponent } from './components/required-documents/required-documents.component';
import { AdditionalInformationComponent } from './components/additional-information/additional-information.component';
import { FamilyInformationComponent } from './components/family-information/family-information.component';
import { EnterProcessingInformationComponent } from './components/enter-processing-information/enter-processing-information.component';
import { ImmigrationHistoryComponent } from './components/immigration-history/immigration-history.component';
import { VdApplicantDetailsComponent } from './components/vd-applicant-details/vd-applicant-details.component';
import { VdFamilyImmigrantDocumentsComponent } from './components/vd-family-immigrant-documents/vd-family-immigrant-documents.component';

import { TaskNotesLibModule } from 'task-notes-lib';
import {MatTabsModule} from '@angular/material/tabs';
import { TooltipModule } from 'primeng/tooltip';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import { TaskAllocationModule } from '../task-allocation/task-allocation.module';
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { DocumentChecklistLibraryModule } from 'document-checklist-library';

import { EditorModule } from '@progress/kendo-angular-editor';
import { CustomKendoModule } from '../custom-kendo/custom-kendo.module';
import { InCareOfNameModule } from 'in-care-of-name';
import { SharedModule } from '../shared/shared.module';
import { CustomStepsComponent } from './components/custom-steps/custom-steps.component';
import { LockUnlockStepsLibraryModule } from 'lock-unlock-steps-library';
import { ExternalLinksModule } from 'external-links';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import { UpdateDeterminationComponent } from './components/update-determination/update-determination.component';
import { CustomQuestionnaireModule } from 'custom-questionnaire';
import { LcaContainerModule } from 'projects/lca-container/src/lib/lca-container.module';
import { NotificationDialogComponent } from './components/notification-dialog/notification-dialog.component';
import { NotificationViewModule } from 'notification-view';
import { LcaAndJobDetailsComponent } from './components/lca-and-job-details/lca-and-job-details.component';
import { IndividualsDetailsComponent } from './components/individuals-details/individuals-details.component';
import { JobDescriptionLcaPositionLibraryModule } from 'projects/job-description-lca-position-library/src/lib/job-description-lca-position-library.module';
import { JobDescriptionLcaWorkLibraryModule } from 'projects/job-description-lca-work-library/src/projects';
import { LcaJobDetailsPositionComponent } from './components/lca-job-details-position/lca-job-details-position.component';
import { SelectingLcaSocLibraryModule } from 'selecting-lca-soc-library';
import { LcaJobDetailsWorkComponent } from './components/lca-job-details-work/lca-job-details-work.component';
import { LcaSocCodeLibraryModule } from 'lca-soc-code-library';
import { ListJobDutiesModule } from 'list-job-duties';
import { EfilingComponent } from './components/efiling/efiling.component';
//import { BeneficiaryDocumentsEditLibraryModule } from 'projects/beneficiary-documents-edit-library/src/lib/beneficiary-documents-edit-library.module';
//import { EditWorkExperienceDetailsComponent } from './components/edit-work-experience-details/edit-work-experience-details.component';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FileUploadDeafultLibraryModule } from 'file-upload-deafult-library';
//import { EditCompleteEducationDetailLibraryModule } from 'projects/edit-complete-education-detail-library/src/lib/edit-complete-education-detail-library.module';
//import { SimpleExperienceDetailLibraryModule } from 'simple-experience-detail-library';
//import { SimpleImmigrationDetailLibraryModule } from 'simple-immigration-detail-library';
import { OtherInformationComponent } from './components/other-information/other-information.component';
import { DocumentChecklistNewLibraryModule } from 'document-checklist-new-library';
import { GenericBeneficiaryImmigrationDetailsLibraryModule } from 'generic-beneficiary-immigration-details-library';
import { WorkExperienceDetailsLibraryModule } from 'work-experience-details-library';
import { GenericBeneficiaryWorkExperienceModule } from 'generic-beneficiary-work-experience';
import { GenericBeneficiaryPersonalDetailsLibraryModule } from 'generic-beneficiary-personal-details-library';


@NgModule({
  declarations: [
    ProcessingInformationComponent,
    UpdateSubTaskDetailsComponent,
    I140SubheaderComponent,
    I140TimelineComponent,
    L1OutsideImagilityComponent,
    MainContainerComponent,
    StatusUpdateComponent,
    JobDescriptionComponent,
    JobDutiesComponent,
    AddDutyComponent,
    BeneficiaryPersonalDetailsComponent,
    EducationDetailsComponent,
    DeleteDialogComponent,
    DependentDetailsComponent,
    PetitionerDetailsComponent,
    GetReceiptsComponent,
    SubmitPetitionComponent,
    PrintPetitionComponent,
    UscisContentComponent,
    NoteDialogComponent,
    ReviewI140PetitionComponent,
    LetterGenerationComponent,
    I140FileUploadComponent,
    BeneficiaryDocumentsComponent,
    UpdateDecisionComponent,
    PastJobDescriptionComponent,
    PetitionerDetailsForeignCompanyComponent,
    WorkExperienceDetailsComponent,
    USCISH1BLotteryComponent,
    AwaitLotterySelectionComponent,
    ItineraryOfServicesComponent,
    SpecialityOccupationComponent,
    OccupationDeterminationComponent,
    OccupationDetailsComponent,
    LcaComponent,
    H1bJobDescriptionComponent,
    ProvideEERComponent,
    SupervisorDetailsComponent,
    ProjectDetailsComponent,
    ClientProjectDocumentsComponent,
    // ConsulateAddressComponent,
    EnterEntitiesRelationshipDetailsComponent,
    H1bPetitionerDetailsComponent,
    PetitionUpdateInitComponent,
    SponserPersonalDetailComponent,
    ProvideInformationContainerComponent,
    AddressHistoryComponent,
    MembershipAssociationComponent,
    ResearchContributionComponent,
    CaptureExtraordinaryAbilityDetailsComponent,
    NationalInternationalPrizesComponent,
    AuthorAndPublicationComponent,
    HighsalaryRemunerationComponent,
    ArtisticExhibitionsShowcasesComponent,
    ProfessionalPublicationsComponent,
    ParticipationAsJudgeComponent,
    EmploymentEssentialCriticalCapacityComponent,
    PortEntryComponent,
    OutsideImagilityComponent,
    CustomStepsFormComponent,
    VdJobDescriptionComponent,
    VdProvidePetitionerDetailsComponent,
    AddressComponent,
    MaritalHistoryComponent,
    ParentInformationComponent,
    EmploymentHistoryComponent,
    RequiredDocumentsComponent,
    AdditionalInformationComponent,
    FamilyInformationComponent,
    ImmigrationHistoryComponent,
    EnterProcessingInformationComponent,
    VdApplicantDetailsComponent,
    VdFamilyImmigrantDocumentsComponent,
    UpdateDeterminationComponent,
    CustomStepsComponent,
    NotificationDialogComponent,
    LcaAndJobDetailsComponent,
    IndividualsDetailsComponent,
    LcaJobDetailsPositionComponent,
    LcaJobDetailsWorkComponent,
    EfilingComponent,
    EfilingSettingComponent,
    OtherInformationComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    PrimengLibraryModule,
    ReactiveFormsModule,
    FormsModule,
    NgxExtendedPdfViewerModule,
    PdfViewerModule,
    NgbTooltipModule,
    NgxPermissionsModule,
    L1RoutingModule,
    PlaceHolderLibraryModule,
    // FroalaEditorModule.forRoot(),
    // FroalaViewModule.forRoot(),
    StoreModule.forFeature(fromStore.storeFeatureKey, fromStore.reducers, { metaReducers: fromStore.metaReducers }),
    EffectsModule.forFeature([fromStore.SubTaskDetailsEffects, fromStore.StepStatusUpdateEffects]),
    BeneficiaryPersonalDetailsLibraryModule,
    EducationDetailsLibraryModule,
    GenericBeneficiaryPersonalDetailsLibraryModule,
    GenericBeneficiaryImmigrationDetailsLibraryModule,
    BeneficiaryDocumentsLibraryModule,
    DateFormatModule,
    FileUploadLibraryModule,
    SubmitPetitionLibraryModule,
    GetReceiptsLibraryModule,
    MailingAddressLibraryModule,
    FeeCalculationLibraryModule,
    ConsulateAddressLibraryModule,
    GenerateFormsLibraryModule,
    UscisContentLibraryModule,
    ReviewCommentsLibraryModule,
    ReviewPetitionLibraryModule,
    PrintPetitionLibraryModule,
    LetterGenerationEntryLibraryModule,
    CoverLetterLibraryModule,
    SupportLetterLibraryModule,
    OrganizeDocumentsLibraryModule,
    LetterPreviewLibraryModule,
    LetterTemplateLibraryModule,
    CreateTemplateLibraryModule,
    LetterGenerationLibraryModule,
    PetitionerDetailsLibraryModule,
    StepStatusUpdateComponentLibraryModule,
    LcaContainerModule,
    PetitionAnalysisContainerModule,
    ItineraryOfServicesLibraryModule,
    LastUpdateLibraryModule,
    JobDescriptionLibraryModule,
    JobDescriptionLcaPositionLibraryModule,
    JobDescriptionLcaWorkLibraryModule,
    UpdateEmploymentModule,
    HelpVideoOverlayLibraryModule,
    PdfViewLibraryModule,
    EnterEntitiesRelationshipDetailsLibraryModule,
    FileUploadLibraryModule,    
    FileUploadDeafultLibraryModule,
    VisaDesignerModule,
    SendNotificationModule,
    NotificationComponentLibraryModule,
    SendBackComponentLibraryModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTableModule,
    MatDividerModule,
    MatRadioModule,
    MatInputModule,
    MatSlideToggleModule,
    MatCardModule,    
    MatDatepickerModule,
    MatMomentDateModule,
    MatChipsModule,
    MatIconModule,
    MatListModule,
    MatFormFieldModule,
    TaskNotesLibModule,
    MatTabsModule,
    TooltipModule,
    AssigningTaskLibraryModule,
    TaskAllocationModule,
    //GreenCardI140Module,
    DocumentChecklistLibraryModule,
    DocumentChecklistNewLibraryModule,
    EditorModule,
    CustomKendoModule,
    InCareOfNameModule,
    LockUnlockStepsLibraryModule,
    ExternalLinksModule,
    MaximizeDialogLibraryModule,
    CustomQuestionnaireModule,
    NotificationViewModule,
    SelectingLcaSocLibraryModule,
    LcaSocCodeLibraryModule,
    ListJobDutiesModule,
    // SimplePersonalDetailLibraryModule,
    // EditCompletePersonalDetailLibraryModule,  
    // Gci140EditPersonalDetailLibraryModule,
    WorkExperienceDetailsLibraryModule,
    GenericBeneficiaryWorkExperienceModule
  ],
  exports: [I140TimelineComponent,ClientProjectDocumentsComponent,ProjectDetailsComponent,SupervisorDetailsComponent],
  bootstrap: [I140TimelineComponent],
  providers: [StepStatusUpdatePayload],
  entryComponents: [
    UpdateDeterminationComponent
  ]
})
export class L1Module { }
